// extracted by mini-css-extract-plugin
export default {"BottomButton":"BottomButton_BottomButton__X-Cya","Button":"BottomButton_Button__VS6Sw"};